import { datadogRum } from '@datadog/browser-rum';
const FULLY_QUALIFIED_ENVIRONMENT = `${process.env.APP_ENV}-${process.env.APP_MODE}`;
const applicationId = process.env.DATADOG_APPLICATION_ID;
const clientToken = process.env.DATADOG_CLIENT_TOKEN;
if (!applicationId || !clientToken) {
    console.error('Datadog applicationId or clientToken missing');
}
else {
    datadogRum.init({
        applicationId,
        clientToken,
        site: 'datadoghq.com',
        service: 'payment-account-linking-intent-ui',
        env: FULLY_QUALIFIED_ENVIRONMENT,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input'
    });
    datadogRum.startSessionReplayRecording();
}
